export const ButtonNext = () => import('../../../../components/ButtonNext.vue' /* webpackChunkName: "components/button-next" */).then(c => wrapFunctional(c.default || c))
export const Conseil = () => import('../../../../components/Conseil.vue' /* webpackChunkName: "components/conseil" */).then(c => wrapFunctional(c.default || c))
export const Footer = () => import('../../../../components/Footer.vue' /* webpackChunkName: "components/footer" */).then(c => wrapFunctional(c.default || c))
export const Formrefs = () => import('../../../../components/Formrefs.vue' /* webpackChunkName: "components/formrefs" */).then(c => wrapFunctional(c.default || c))
export const FormulaireFoot = () => import('../../../../components/FormulaireFoot.vue' /* webpackChunkName: "components/formulaire-foot" */).then(c => wrapFunctional(c.default || c))
export const Formulairehero = () => import('../../../../components/Formulairehero.vue' /* webpackChunkName: "components/formulairehero" */).then(c => wrapFunctional(c.default || c))
export const Header = () => import('../../../../components/Header.vue' /* webpackChunkName: "components/header" */).then(c => wrapFunctional(c.default || c))
export const Hero = () => import('../../../../components/Hero.vue' /* webpackChunkName: "components/hero" */).then(c => wrapFunctional(c.default || c))
export const Integration = () => import('../../../../components/Integration.vue' /* webpackChunkName: "components/integration" */).then(c => wrapFunctional(c.default || c))
export const Navbar = () => import('../../../../components/Navbar.vue' /* webpackChunkName: "components/navbar" */).then(c => wrapFunctional(c.default || c))
export const Newsletter = () => import('../../../../components/Newsletter.vue' /* webpackChunkName: "components/newsletter" */).then(c => wrapFunctional(c.default || c))
export const Outils = () => import('../../../../components/Outils.vue' /* webpackChunkName: "components/outils" */).then(c => wrapFunctional(c.default || c))
export const Pricing = () => import('../../../../components/Pricing.vue' /* webpackChunkName: "components/pricing" */).then(c => wrapFunctional(c.default || c))
export const PricingRunner = () => import('../../../../components/PricingRunner.vue' /* webpackChunkName: "components/pricing-runner" */).then(c => wrapFunctional(c.default || c))
export const Testimonial = () => import('../../../../components/Testimonial.vue' /* webpackChunkName: "components/testimonial" */).then(c => wrapFunctional(c.default || c))
export const Value = () => import('../../../../components/Value.vue' /* webpackChunkName: "components/value" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
